"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var DEFAULT_HOVER_BORDER_COLOR = "\n  border-color: var(--color-hover-blue);\n";
var DEFAULT_ACTIVE_BORDER_COLOR = "\n  border-color: var(--color-text-blue);\n";

var InputWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n  font-family: var(--font-sans);\n"])));

var InputLabel = _styledComponents.default.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 11px;\n  text-transform: uppercase;\n"])), function (props) {
  return props.hasError ? 'var(--color-error)' : props.isFocused ? '#606060' : '#9B9B9B';
});

var Input = _styledComponents.default.input(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  height: 40px;\n  box-sizing: border-box;\n  padding-left: 5px;\n  -webkit-appearance: none;\n  border: none;\n  border-bottom: 1px solid;\n  border-radius: 0;\n  border-color: ", ";\n  color: ", ";\n  font-size: 15px;\n  font-family: var(--font-sans);\n  font-weight: 400;\n  &:placeholder {\n    color: #9b9b9b;\n  }\n  &:hover {\n    ", "\n  }\n  &:focus {\n    ", "\n    outline: none;\n  }\n"])), function (props) {
  return props.hasError ? 'var(--color-error)' : '#A4C2D5';
}, function (props) {
  return props.hasError ? 'var(--color-error)' : 'var(--color-text-black)';
}, DEFAULT_HOVER_BORDER_COLOR, DEFAULT_ACTIVE_BORDER_COLOR);

var _default = {
  Input: Input,
  InputWrapper: InputWrapper,
  InputLabel: InputLabel
};
exports.default = _default;